export default __webpack_public_path__ + "static/media/servipag.c243e7bd.svg";